/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ platform: NonNullable<unknown> }} Pc_Dl_ForInputs */

const en_pc_dl_for = /** @type {(inputs: Pc_Dl_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Download PdfCraft for ${i?.platform}`)
};

const zh_pc_dl_for = /** @type {(inputs: Pc_Dl_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`下载 PdfCraft ${i?.platform} 版`)
};

/**
* | output |
* | --- |
* | "Download PdfCraft for {platform}" |
*
* @param {Pc_Dl_ForInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_for = /** @type {((inputs: Pc_Dl_ForInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_ForInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_for(inputs)
	return zh_pc_dl_for(inputs)
});
export { pc_dl_for as "pc.dl.for" }